import Cookies from 'js-cookie';

const COOKIE_KEY = 'DEV_ENVIRONMENT_ADMIN';

export const DEV_ENVIRONMENTS = [
    {
        name: 'PRODUCTION',
        config: {
            ADMIN_API_URL: 'https://be-cfmpro.forcemanager.net/api',
            BACKEND2_API_URL: 'https://be-pro.forcemanager.net',
            WEBAPP_URL: 'https://app.forcemanager.net',
            CFM_URL: 'https://cfm.forcemanager.net/Login.aspx',
        },
    },
    {
        name: 'PREPRODUCTION',
        config: {
            ADMIN_API_URL: 'https://be-cfmpre.forcemanager.net/api',
            BACKEND2_API_URL: 'https://be-pre.forcemanager.net',
            WEBAPP_URL: 'https://app-pre.forcemanager.net',
            CFM_URL: 'https://cfm-pre.forcemanager.net/Login.aspx',
        },
    },
    {
        name: 'STAGING',
        config: {
            ADMIN_API_URL: 'https://be-cfmsta.forcemanager.net/api',
            BACKEND2_API_URL: 'https://be-sta.forcemanager.net',
            WEBAPP_URL: 'https://app-sta.forcemanager.net',
            CFM_URL: 'https://cfm-sta.forcemanager.net/Login.aspx',
        },
    },
];

export const loadDevEnvironment = (key) => {
    const configKey = key || Cookies.get(COOKIE_KEY) || 'PREPRODUCTION';
    window.FM_CONFIG = {
        ...(window.FM_CONFIG || {}),
        ...(DEV_ENVIRONMENTS.find((item) => configKey === item.name)?.config || {}),
    };
};

export const getDevEnvironment = () => {
    return Cookies.get(COOKIE_KEY);
};

export const setDevEnvironment = (key = '') => {
    Cookies.set(COOKIE_KEY, key, { secure: true, sameSite: 'Strict' });
};
